export const state = {
  teachers: []
}
